var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background-color":"#e1e2fa","padding-left":"10px","padding-right":"10px","height":"50px","border-radius":"5px"}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }